import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CTAButton } from './CTAButton';
import { BookOpen, PartyPopper, ChefHat, Leaf, Gift } from 'lucide-react';
export function OfferSection() {
  const items = [{
    icon: <BookOpen className="w-6 h-6" data-id="element-90" />,
    tag: 'EBOOK PRINCIPAL',
    title: 'Manual de Digestión Ligera',
    desc: 'Vuelve a disfrutar de la mesa sin el miedo al ardor nocturno.',
    value: '$80'
  }, {
    icon: <PartyPopper className="w-6 h-6" data-id="element-91" />,
    tag: 'BONO 1 · GRATIS',
    title: 'Protocolo "Fuera de Casa"',
    desc: 'Cómo sobrevivir a fiestas, bodas y restaurantes.',
    value: '$30'
  }, {
    icon: <ChefHat className="w-6 h-6" data-id="element-92" />,
    tag: 'BONO 2 · GRATIS',
    title: 'Sazón Sin Fuego',
    desc: 'El Recetario de Sofritos Seguros.',
    value: '$30'
  }, {
    icon: <Leaf className="w-6 h-6" data-id="element-93" />,
    tag: 'BONO 3 · GRATIS',
    title: 'La Farmacia en Tu Alacena',
    desc: 'Guía de Hierbas para el Latino 50+.',
    value: '$30'
  }];
  return <SectionWrapper bgColor="forest" className="text-center" id="oferta" data-id="element-94">
      <div className="max-w-2xl mx-auto" data-id="element-95">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-4 leading-tight" data-id="element-96">
          Recupera tus noches y tu placer por la comida hoy mismo.
        </h2>

        <p className="text-xl text-brand-cream/90 mb-10" data-id="element-97">
          Hoy te llevas el manual completo{' '}
          <span className="font-bold text-brand-amber" data-id="element-98">+ 3 bonos GRATIS</span>{' '}
          por el precio de uno.
        </p>

        {/* Bundle items */}
        <div className="bg-brand-forest/40 border border-brand-amber/30 rounded-3xl p-6 md:p-8 mb-8 text-left" data-id="element-99">
          <div className="flex items-center justify-center gap-2 mb-6" data-id="element-100">
            <Gift className="w-6 h-6 text-brand-amber" data-id="element-101" />
            <p className="text-brand-amber font-bold uppercase tracking-wider text-sm text-center" data-id="element-102">
              Esto es lo que recibes hoy
            </p>
          </div>

          <ul className="space-y-4" data-id="element-103">
            {items.map((item, index) => <li key={index} className="flex items-start gap-4 bg-white/5 border border-white/10 rounded-2xl p-4" data-id="element-104">
                <div className="bg-brand-amber/20 text-brand-amber p-3 rounded-xl flex-shrink-0" data-id="element-105">
                  {item.icon}
                </div>
                <div className="flex-1 min-w-0" data-id="element-106">
                  <p className="text-xs font-bold text-brand-amber tracking-wider mb-1" data-id="element-107">
                    {item.tag}
                  </p>
                  <h3 className="font-serif text-lg md:text-xl font-bold text-white leading-tight mb-1" data-id="element-108">
                    {item.title}
                  </h3>
                  <p className="text-sm text-brand-cream/80" data-id="element-109">{item.desc}</p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-110">
                  <p className="text-xs text-brand-cream/60 uppercase" data-id="element-111">Valor</p>
                  <p className="font-bold text-white" data-id="element-112">{item.value}</p>
                </div>
              </li>)}
          </ul>

          <div className="border-t border-white/20 mt-6 pt-4 flex items-center justify-between" data-id="element-113">
            <p className="text-white font-bold text-lg" data-id="element-114">Valor total real:</p>
            <p className="text-2xl font-bold text-gray-400 line-through" data-id="element-115">
              $170 USD
            </p>
          </div>
        </div>

        {/* Price card */}
        <div className="bg-white text-brand-forest p-8 rounded-3xl shadow-2xl mb-6 transform scale-105" data-id="element-116">
          <p className="text-sm font-bold text-brand-amber uppercase tracking-wider mb-2" data-id="element-117">
            Hoy lo llevas todo por
          </p>
          <div className="text-2xl md:text-3xl text-gray-400 line-through mb-2" data-id="element-118">
            $170 USD
          </div>
          <div className="text-6xl md:text-7xl font-black text-brand-forest mb-1 tracking-tighter" data-id="element-119">
            $17
            <span className="text-3xl md:text-4xl text-brand-forest font-bold" data-id="element-120">
              .00
            </span>{' '}
            <span className="text-2xl text-gray-400 font-bold" data-id="element-121">USD</span>
          </div>
          <p className="text-sm font-bold text-brand-amber uppercase tracking-wide mb-4" data-id="element-122">
            ¡Oferta por tiempo limitado!
          </p>
          <p className="text-sm text-gray-600 mb-2" data-id="element-123">
            Ahorras <span className="font-bold text-brand-cta" data-id="element-124">$153 USD</span> ·
            Pago único
          </p>

          <div className="mt-6" data-id="element-125">
            <CTAButton className="w-full" data-id="element-126" />
          </div>
        </div>
      </div>
    </SectionWrapper>;
}